import React from "react";
import { NextPage } from "next";
import { useApi } from "services/ApiService";
import { ExtendedNextPageContext } from "types/app";
import Page404 from "./404/404";
import Page500 from "./500/500";

// Don`t create a custom 404.js page because it overrides this page.
// The 404.js page cannot have getInitialProps/getServerSideProps

type Props = {
  statusCode: number;
  requestTraceId?: string;
};

const Errors: NextPage<Props> = ({
  statusCode = 500,
  requestTraceId,
}: Props) => {
  const traceId =
    requestTraceId ||
    (typeof window !== "undefined"
      ? window.__NEXT_DATA__?.props?.traceId
      : undefined);
  const { getLastErrorTraceId } = useApi();
  const apiTraceId = getLastErrorTraceId();

  if (statusCode === 404) return <Page404 />;

  return (
    <Page500 statusCode={statusCode} requestTraceId={apiTraceId || traceId} />
  );
};

/* todo: refactor this, add decorator for catch errors on pages */
Errors.getInitialProps = async ({
  req,
  res,
  err,
}: ExtendedNextPageContext): Promise<Props> => {
  let requestTraceId;

  if (res && err?.statusCode) {
    res.statusCode = err.statusCode;
  }

  if (req) {
    requestTraceId = req?.headers["uber-trace-id"];
  }

  const statusCode = res ? res.statusCode : err ? err.statusCode : 404;

  return { statusCode, requestTraceId };
};

Errors.displayName = "Errors";

export default Errors;
